/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Anywhere_HeadingInputs */

const en_funnel_sq_anywhere_heading = /** @type {(inputs: Funnel_Sq_Anywhere_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take it anywhere you go.`)
};

const es_funnel_sq_anywhere_heading = /** @type {(inputs: Funnel_Sq_Anywhere_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llévalo a donde vayas.`)
};

/**
* | output |
* | --- |
* | "Take it anywhere you go." |
*
* @param {Funnel_Sq_Anywhere_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_anywhere_heading = /** @type {((inputs?: Funnel_Sq_Anywhere_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Anywhere_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_anywhere_heading(inputs)
	return en_funnel_sq_anywhere_heading(inputs)
});